import { computed, Directive, input, output } from '@angular/core';

import { LayerEditUiConfig } from '@connect-services/client/services/map-edit-mode.service';

@Directive()
export abstract class AbstractEditActionButton {
    public readonly actionClick = output<void>();
    public readonly hasPermission = input<boolean>(true);
    public readonly isAvailable = input<boolean>(true);
    public readonly isEditable = input<boolean>(true);
    public readonly isEnabled = computed<boolean>(
        () => this.hasPermission() && this.isAvailable() && this.isEditable(),
    );
    public readonly layerEditConfig = input<LayerEditUiConfig | null>(null);
    public readonly tooltipKey = computed<string | null>(() => this.resolveTooltip());

    public onClick(event: MouseEvent): void {
        event.stopPropagation();

        if (!this.isEnabled()) {
            return;
        }
        this.actionClick.emit();
    }

    protected abstract resolveTooltip(): string | null;
}
